module.exports = __webpack_public_path__ + "static/img/mp3.fb994a67.png";